import React from 'react';
import { useTranslation } from 'react-i18next';

interface TableHeaderSectionProps {
  total: number;
  kpis?: any;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, kpis }) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-group-line ri-22px"></i>
            <h5 className="mx-3 my-0">
              {t('users.list.pageTexts.table.headerSection.users')} ({total})
            </h5>
          </div>

          {kpis && (
            <div className="d-flex align-items-center">
              <span className="me-1 fw-semibold">
                {t('users.list.pageTexts.table.headerSection.admin')}:
              </span>
              <span className="badge bg-secondary me-2">{kpis.admin_users ?? 0}</span>

              <span className="mx-2">|</span>

              <span className="me-1 fw-semibold">
                {t('users.list.pageTexts.table.headerSection.backOffice')}:
              </span>
              <span className="badge bg-warning me-2">{kpis.back_office_users ?? 0}</span>

              <span className="mx-2">|</span>

              <span className="me-1 fw-semibold">
                {t('users.list.pageTexts.table.headerSection.channelPartner')}:
              </span>
              <span className="badge bg-info me-2">{kpis.channel_partner_users ?? 0}</span>

              <span className="mx-2">|</span>

              <span className="me-1 fw-semibold">
                {t('users.list.pageTexts.table.headerSection.developer')}:
              </span>
              <span className="badge bg-primary me-2">{kpis.developer_users ?? 0}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableHeaderSection;
